import Vue from 'vue'
import Router from 'vue-router'

import Login from "@/pages/Login"

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/home',
      redirect: '/actmanage'
    },
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/',
        component: resolve => require(['../pages/home/Home.vue'], resolve),
        meta: { title: '首页' },
        children:[
            {
                path: '/actmanage',
                component: resolve => require(['../pages/home/components/ActManage.vue'], resolve),
                meta: { title: '活动管理' }
            },
            {
                path: '/registrationlist',
                name: 'RegistrationList',
                component: resolve => require(['../pages/home/components/RegistrationList.vue'], resolve),
                meta: { title: '报名列表' },
            },
            {
                path: '/releaseact',
                name: 'ReleaseActivity',
                component: resolve => require(['../pages/home/components/ReleaseActivity.vue'], resolve),
                meta: { title: '发布活动' }
            },
            {
                path: '/companyinfo',
                component: resolve => require(['../pages/home/components/CompanyInfo.vue'], resolve),
                meta: { title: '公司信息' }
            },
        ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js